import { create } from "zustand";
import type { EventMessage } from "../services/types";
import type { ConnectionStatus } from "../services/stomp.service";
import { MAX_EVENTS } from "../services/config";

interface EventsState {
  stompEvents: EventMessage[];
  connectionStatus: ConnectionStatus;
}

interface EventsActions {
  addStompEvent: (event: EventMessage) => void;
  /**
   * 버퍼를 비운다. **계정이 바뀔 때 반드시 불러야 한다** — 이 스토어는 모듈 레벨이라
   * 로그아웃(페이지 리로드가 아니라 `navigate("/login")`)으로는 살아남고, 앞 계정이
   * 받아둔 이벤트가 다음 계정의 알림함에 그대로 남는다. 접근 권한 없는 현장의
   * 이벤트일 수 있다(`QueryProvider` 가 캐시를 지우는 것과 같은 이유).
   */
  clearStompEvents: () => void;
  setConnectionStatus: (status: ConnectionStatus) => void;
}

type EventsStore = EventsState & EventsActions;

export const useEventsStore = create<EventsStore>()((set) => ({
  stompEvents: [],
  connectionStatus: "disconnected",

  addStompEvent: (event) =>
    set((state) => ({
      stompEvents: [event, ...state.stompEvents].slice(0, MAX_EVENTS),
    })),

  clearStompEvents: () => set({ stompEvents: [] }),

  setConnectionStatus: (connectionStatus) => set({ connectionStatus }),
}));

// Selectors
export const selectStompEvents = (state: EventsStore) => state.stompEvents;
